<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('Task')" :directory="$t('transaction')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <!-- <button type="button"
                            class="btn btn-success btn-with-shadow"
                            @click="exportAll">
                        {{ $t('export_all') }}
                    </button> -->
                    <button type="button"
                            class="btn btn-primary btn-with-shadow"
                            data-toggle="modal"
                            @click="openAddEditModal">
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
            @action="getListAction"
        />

        <modal-form
            v-if="isAddEditModalActive"
            :table-id="tableId"
            :form-id="formId"
            v-model="rowData"
            :selected-url="selectedUrl"
            @close-modal="closeAddEditModal"
        />

        <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="onDelete"
            @cancelled="onCancelDelete"
        />
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {Schema} from './Schema';
import {urlGenerator} from "../../../../Helpers/AxiosHelper";
import { UserMixin } from "../../Auth/Mixins/UserMixin";

export default {
    extends: CoreLibrary,
    name: "Task",
    mixins: [Schema, UserMixin],
    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        // this.searchAndSelectFilterOptions();
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            let m_id = `#TASK-form`;
            $(m_id).modal('hide');
            this.isAddEditModalActive = false;
            // this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
                this.openAddEditModal();
            } else if (actionObj.title == "Complete Task") {
				Swal.fire({
					title: "Are you sure?",
					text: "You want to Complete Task?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes",
				}).then((result) => {
					if (result.isConfirmed) {
						try {
                            this.axiosPatch({
							url: `/transaction/task/${rowData.id}`,
                            data: {
                                ...rowData,
                                stage_id: 3,
                                assignee_id: rowData.assignee_id ? rowData.assignee_id.id : 1,
                                owner_id: rowData.owner_id ? rowData.owner_id.id : 1,
                                accomplished_by_id: this.user.loggedInUser.id,
                                accomplished_by_name: this.user.loggedInUser.full_name,
                                accomplished_date: this.formattedDate(new Date()),
                                accomplished_time: this.getCurrentTimeFormatted(new Date()),
                            }
						})
							.then((response) => {
								Swal.fire({
									title: "Success!",
									text: "Task has been completed!",
									icon: "success",
									confirmButtonText: "Ok",
								});
							})
							.catch(({ error }) => {
								// Trigger after error
								Swal.fire({
									title: "Error!",
									text: error.response.data.message,
									icon: "error",
									confirmButtonText: "Ok",
								});
							})
							.finally(() => {
                                this.$hub.$emit("reload-TASK-table");
                            });
                        }
                        catch (error) {
                            Swal.fire({
                                title: "Error!",
                                text: error,
                                icon: "error",
                                confirmButtonText: "Ok",
                            });
                        }
					}
				});
			} else if (actionObj.title == "Cancel Task") {
				Swal.fire({
					title: "Are you sure?",
					text: "You want to Cancel Task?",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes",
				}).then((result) => {
					if (result.isConfirmed) {
						try {
                            this.axiosPatch({
							url: `/transaction/task/${rowData.id}`,
                            data: {
                                ...rowData,
                                stage_id: 2,
                                assignee_id: rowData.assignee_id ? rowData.assignee_id.id : 1,
                                owner_id: rowData.owner_id ? rowData.owner_id.id : 1,
                                accomplished_by_id: null,
                                accomplished_by_name: null,
                                accomplished_date: null,
                                accomplished_time: null,
                            }
						})
							.then((response) => {
								Swal.fire({
									title: "Success!",
									text: "Task has been canceled!",
									icon: "success",
									confirmButtonText: "Ok",
								});
							})
							.catch(({ error }) => {
								// Trigger after error
								Swal.fire({
									title: "Error!",
									text: error.response.data.message,
									icon: "error",
									confirmButtonText: "Ok",
								});
							})
							.finally(() => {
                                this.$hub.$emit("reload-TASK-table");
                            });
                        }
                        catch (error) {
                            Swal.fire({
                                title: "Error!",
                                text: error,
                                icon: "error",
                                confirmButtonText: "Ok",
                            });
                        }
					}
				});
			}
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        // searchAndSelectFilterOptions() {
        //     this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
        //         let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

        //         name.option = response.data.map(name => {
        //             return {
        //                 id: name.name,
        //                 value: name.name
        //             }
        //         });
        //     });
        // },

        exportAll() {
            window.location.replace(urlGenerator(DATATABLE_EXPORT))
        },

        formattedDate(dateParam) {
			const originalDate = dateParam;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
        getCurrentTimeFormatted(dateParam) {
			// convert to "20:53:16" format
			const originalDate = dateParam;
			const date = new Date(originalDate);

			const hours = date.getHours().toString().padStart(2, "0");
			const minutes = date.getMinutes().toString().padStart(2, "0");
			const seconds = date.getSeconds().toString().padStart(2, "0");

			const formattedTime = `${hours}:${minutes}:${seconds}`;

			return formattedTime;
		},
    },
}
</script>
